/* rv24-search.js — Suche fuer rohrverbinder24.eu, 12.09.2026
 *
 * Ersetzt das jQuery-Autocomplete von 2016 (snippets/search-autocomplete.liquid).
 * Vanilla JS, keine Abhaengigkeiten, laeuft in allen acht Shopsprachen.
 *
 * Leistet:
 *  1. Vorschlaege beim Tippen ueber /search/suggest.json mit Bild, Titel,
 *     Artikelnummer und Preis.
 *  2. Artikelnummern (101D48, 101D48/C42, 11.3330.4, 88.1110144040, …-K30):
 *     eigene Abfrage mit fields=variants.sku, die ausschliesslich das
 *     SKU-Feld durchsucht. Ein eindeutiger Treffer wird mit Enter direkt
 *     geoeffnet und steht auf der Ergebnisseite ganz oben. Die
 *     Standardsuche kann das nicht: sie mischt Titel- und
 *     Beschreibungstreffer dazwischen, und die Temperguss-Beschreibungen
 *     listen jeweils alle Groessen der Baureihe.
 *  3. Schreibweisen: Eckstueck = Eckstück, 42.4 = 42,4, Kurzcodes C42/D48,
 *     Zollmasse, dazu Synonyme und die Fachbegriffe der anderen Sprachen.
 *  4. Typ + Durchmesser + Material werden aus der Eingabe gelesen und als
 *     Tag-Filter-URL angeboten (collections/all/<typ>+<durchmesser>).
 *     Das ist der Kern: die Shopify-Volltextsuche verknuepft Begriffe mit
 *     ODER, deshalb liefert 'Eckstück 42,4' 120 statt 3 Treffer.
 *
 * Konfiguration kommt aus window.RV24S (snippets/rv24-search-head.liquid).
 */
(function () {
  var C = window.RV24S;
  if (!C) { return; }
  var T = C.t || {};
  var ROOT = (C.root || '/').replace(/\/+$/, '');
  var ALL = (C.allUrl || (ROOT + '/collections/all')).replace(/\/+$/, '');
  var TAGS = C.tags || [];

  /* ---------------------------------------------------------- Normalisierung */

  function fold(s) {
    return (s || '')
      .toString()
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .replace(/ø/g, ' ')
      .replace(/[^a-z0-9.,\/ -]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  var DIA_ALIAS = [
    ['t21', '21.3'], ['a27', '26.9'], ['b34', '33.7'],
    ['c42', '42.4'], ['d48', '48.3'], ['e60', '60.3'],
    ['1/2', '21.3'], ['3/4', '26.9'], ['1 1/4', '42.4'], ['1 1/2', '48.3']
  ];

  var SYN = {
    'T-Stück': ['t stueck', 'tstueck', 't-stueck', 't stuck', 'tee', 'tees', 'abzweig', 'trojnik'],
    'Kreuzstück': ['kreuz', 'kreuzstueck', 'cross', 'crosses', 'croix', 'croce', 'cruz', 'krzyzak'],
    'Eckstück': ['eck', 'eckstueck', 'ecke', 'winkel', 'knie', 'corner', 'coin', 'angolo', 'esquina', 'narozni'],
    'Fußplatte': ['fussplatte', 'bodenplatte', 'flansch', 'fuss', 'base flange', 'platine', 'piastra', 'brida', 'stopa'],
    'Bodenhülse': ['bodenhuelse', 'huelse', 'einbauhuelse', 'ground socket', 'douille', 'bussola', 'casquillo'],
    'Endkappe': ['endkappe', 'kappe', 'stopfen', 'deckel', 'abdeckkappe', 'end cap', 'bouchon', 'tappo', 'tapon', 'zaslepka'],
    'Bogen': ['bogen', 'kruemmer', 'kurve', 'elbow', 'coude', 'curva', 'codo', 'kolanko', 'koleno'],
    'Endbogen': ['endbogen', 'end elbow'],
    'Handlaufhalterung': ['handlauf', 'handlaufhalter', 'handrail', 'main courante', 'corrimano', 'pasamanos'],
    'Gitterhalter': ['gitter', 'gitterhalter', 'mesh', 'grillage'],
    'Schneidschrauben': ['schraube', 'schrauben', 'madenschraube', 'innensechskant', 'grub screw', 'tornillo'],
    'Verlängerungsstück': ['verlaengerung', 'muffe', 'verbindungsmuffe', 'coupling', 'manchon', 'manicotto', 'manguito'],
    'Reduzierstück': ['reduzier', 'reduzierung', 'adapter', 'reducer', 'reduction', 'riduzione', 'reduccion'],
    'Gelenke': ['gelenk', 'gelenkstueck', 'verstellbar', 'swivel', 'rotule', 'snodo', 'articulado'],
    'Geländerpfosten': ['pfosten', 'gelaenderpfosten', 'poteau', 'poste', 'slupek'],
    'Wetterkappe': ['wetterkappe', 'regenkappe', 'haube', 'weather cap'],
    'Stellring': ['stellring', 'anschlagring', 'collar', 'bague', 'collare'],
    'Rohrsattel': ['sattel', 'rohrsattel', 'saddle', 'selle'],
    'Wandbefestigung': ['wandhalter', 'wandbefestigung', 'wandflansch', 'wall flange', 'mural', 'parete', 'pared'],
    'Verbindungsstück': ['verbinder', 'verbindungsstueck', 'joiner', 'jonction', 'giunto', 'union'],
    'Stabverbinder': ['stabverbinder', 'rundstab', 'bar connector'],
    'Drehstück': ['drehstueck', 'drehbar', 'rotating'],
    'Traufenstück': ['traufe', 'traufenstueck', 'eaves'],
    'Befestigungsring': ['befestigungsring', 'fixing ring'],
    'Kunststoffstopfen': ['kunststoffstopfen', 'plastikstopfen', 'plastic plug'],
    'Rohrhalter': ['rohrhalter', 'tube support'],
    'Anschlussstück': ['anschlussstueck', 'anschluss', 'connector'],
    'Verbindungsring': ['verbindungsring', 'connecting ring'],
    'Temperguss': ['temperguss', 'feuerverzinkt', 'verzinkt', 'galvanized', 'malleable', 'ghisa', 'fundicion'],
    'Edelstahl': ['edelstahl', 'inox', 'stainless', 'rostfrei', 'acciaio inox', 'acero inoxidable', 'nierdzewna', 'nerez'],
    'V2A': ['v2a', '1.4301', 'aisi 304'],
    'V4A': ['v4a', '1.4401', '1.4404', 'aisi 316']
  };

  var FILLER = [
    'rohrverbinder', 'rohverbinder', 'rohrverbindung', 'rohrverbinder24',
    'key clamp', 'kee klamp', 'keeklamp', 'pipe clamp', 'clamp', 'fitting', 'fittings',
    'buiskoppeling', 'buiskoppelingen', 'raccord tubulaire', 'raccords tubulaires',
    'raccordo', 'raccordi per tubi', 'conector tubular', 'conectores tubulares',
    'zlaczki rurowe', 'zlaczka rurowa', 'trubkove spojky', 'trubkova spojka',
    'rohr', 'tube', 'tubo', 'rura', 'mm', 'fuer', 'for'
  ];

  function diaTags() { return TAGS.filter(function (t) { return t.k === 'dia'; }); }

  function diaNum(tag) {
    var m = (tag.n || '').match(/(\d+([.,]\d+)?)/);
    return m ? m[1].replace(',', '.') : '';
  }

  function findDiaTag(num) {
    var d = diaTags();
    for (var i = 0; i < d.length; i++) { if (diaNum(d[i]) === num) { return d[i]; } }
    return null;
  }

  function detectSku(raw) {
    var s = (raw || '').toUpperCase().replace(/\s+/g, '');
    if (/^[0-9]{2,3}[A-Z]{0,2}[TABCDE][0-9]{2}(\/[A-Z][0-9]{2})?(-K[0-9]+)?$/.test(s)) { return s; }
    if (/^[0-9]{2}\.[0-9]{3,4}\.[0-9](-K[0-9]+)?$/.test(s)) { return s; }
    if (/^[0-9]{2}\.[0-9]{6,}(-K[0-9]+)?$/.test(s)) { return s; }
    return null;
  }

  function tagByName(n) {
    for (var i = 0; i < TAGS.length; i++) { if (TAGS[i].n === n) { return TAGS[i]; } }
    return null;
  }

  function needles(tag) {
    var list = [fold(tag.n), fold(tag.l)];
    var s = SYN[tag.n];
    if (s) { list = list.concat(s); }
    return list.filter(function (v) { return v && v.length > 2; });
  }

  function matchesTag(f, tag) {
    var n = needles(tag);
    for (var i = 0; i < n.length; i++) { if (f.indexOf(n[i]) > -1) { return true; } }
    return false;
  }

  function stripTag(f, tag) {
    var n = needles(tag);
    n.sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < n.length; i++) { f = f.split(n[i]).join(' '); }
    return f;
  }

  function parse(raw) {
    var f = ' ' + fold(raw) + ' ';
    var out = { typ: null, dia: null, mat: null, sku: detectSku(raw), raw: raw };
    var i;

    var m = f.match(/\b(\d{2})[.,](\d)\b/);
    if (m) {
      var tag = findDiaTag(m[1] + '.' + m[2]);
      if (tag) { out.dia = tag; f = f.replace(m[0], ' '); }
    }
    if (!out.dia) {
      var q = f.match(/\b(\d{2})\s?x\s?(\d{2})\b/);
      if (q) {
        var want = q[1] + 'x' + q[2];
        var d = diaTags();
        for (i = 0; i < d.length; i++) {
          if (fold(d[i].n).indexOf(want) > -1) { out.dia = d[i]; f = f.replace(q[0], ' '); break; }
        }
      }
    }
    if (!out.dia) {
      for (i = 0; i < DIA_ALIAS.length; i++) {
        var key = DIA_ALIAS[i][0];
        if (f.indexOf(' ' + key + ' ') > -1 || f.indexOf(key + ' ') === 1) {
          var t2 = findDiaTag(DIA_ALIAS[i][1]);
          if (t2) { out.dia = t2; f = f.replace(key, ' '); break; }
        }
      }
    }
    if (!out.dia && out.sku) {
      var c = out.sku.toLowerCase().match(/([tabcde][0-9]{2})/);
      if (c) {
        for (i = 0; i < DIA_ALIAS.length; i++) {
          if (DIA_ALIAS[i][0] === c[1]) { out.dia = findDiaTag(DIA_ALIAS[i][1]); break; }
        }
      }
    }

    var order = ['V4A', 'V2A', 'Edelstahl', 'Temperguss'];
    for (i = 0; i < order.length; i++) {
      var mt = tagByName(order[i]);
      if (mt && matchesTag(f, mt)) { out.mat = mt; f = stripTag(f, mt); break; }
    }
    var typs = TAGS.filter(function (t) { return t.k === 'typ'; });
    typs.sort(function (x, y) { return (y.n || '').length - (x.n || '').length; });
    for (i = 0; i < typs.length; i++) {
      if (matchesTag(f, typs[i])) { out.typ = typs[i]; f = stripTag(f, typs[i]); break; }
    }
    for (i = 0; i < FILLER.length; i++) { f = f.split(' ' + FILLER[i] + ' ').join(' '); }
    out.rest = f.replace(/\s+/g, ' ').trim();
    return out;
  }

  /* ------------------------------------------------------------------ URLs */

  function filterUrl(p) {
    var h = [];
    if (p.typ) { h.push(p.typ.h); }
    if (p.dia) { h.push(p.dia.h); }
    if (p.mat) { h.push(p.mat.h); }
    if (!h.length) { return null; }
    return ALL + '/' + h.join('+');
  }

  function filterLabel(p) {
    var l = [];
    if (p.typ) { l.push(p.typ.l); }
    if (p.dia) { l.push(p.dia.l); }
    if (p.mat) { l.push(p.mat.l); }
    return l.join(' · ');
  }

  function searchTerm(raw) {
    var s = (raw || '').trim();
    if (C.locale === 'en') { return s.replace(/(\d{2}),(\d)\b/g, '$1.$2'); }
    return s.replace(/(\d{2})\.(\d)\b/g, '$1,$2');
  }

  function searchUrl(raw) {
    return ROOT + '/search?type=product&q=' + encodeURIComponent(searchTerm(raw));
  }

  function suggestUrl(raw, types, limit, fields) {
    var u = ROOT + '/search/suggest.json';
    u += '?q=' + encodeURIComponent(raw);
    u += '&resources[type]=' + (types || 'product');
    u += '&resources[limit]=' + (limit || 6);
    u += '&resources[options][unavailable_products]=last';
    if (fields) { u += '&resources[options][fields]=' + fields; }
    return u;
  }

  function getJson(url) {
    return fetch(url).then(function (r) { return r.json(); }).catch(function () { return null; });
  }

  function prods(d) {
    return (d && d.resources && d.resources.results && d.resources.results.products) || [];
  }

  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) { return ''; }
    try {
      return new Intl.NumberFormat(C.locale || 'de', {
        style: 'currency', currency: C.cur || 'EUR'
      }).format(n);
    } catch (e) {
      return n.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function esc(s) {
    return (s || '').toString()
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* Artikelnummer eines Treffers: steht bei Temperguss hinter dem letzten
     Trennstrich im Titel, bei Edelstahl am Ende des Bild-Alt-Textes. */
  function skuOf(item) {
    var m = (item.title || '').match(/\|\s*([0-9][A-Za-z0-9.\/-]{3,})\s*$/);
    if (m) { return m[1]; }
    var alt = (item.featured_image && item.featured_image.alt) || '';
    m = alt.match(/(?:Artikel|–|-)\s*([0-9]{2}\.[0-9]{3,}(?:\.[0-9])?|[0-9]{2,3}[A-Za-z]{0,3}[TABCDEtabcde][0-9]{2}(?:\/[A-Za-z][0-9]{2})?)\s*$/);
    return m ? m[1] : '';
  }

  function isExactSku(item, sku) {
    return (skuOf(item) || '').toUpperCase() === sku.toUpperCase();
  }

  function thumb(item) {
    var src = (item.featured_image && item.featured_image.url) || item.image || '';
    if (!src) { return ''; }
    return src.replace(/(\.(jpg|jpeg|png|webp))(\?|$)/i, '_88x88$1$3');
  }

  function row(it, cls) {
    var sku = skuOf(it);
    var img = thumb(it);
    return '<li' + (cls ? ' class="' + cls + '"' : '') + '><a href="' + esc(it.url) + '">' +
      (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') +
      '<span class="rv24-sugg__txt"><span class="rv24-sugg__title">' + esc(it.title) + '</span>' +
      (sku ? '<span class="rv24-sugg__meta">' + esc(T.itemno) + ' ' + esc(sku) + '</span>' : '') +
      '</span><span class="rv24-sugg__price">' + esc(money(it.price)) + '</span></a></li>';
  }

  /* Treffer einer Artikelnummer-Abfrage sortieren: exakte zuerst */
  function skuRanked(list, sku) {
    var exact = list.filter(function (it) { return isExactSku(it, sku); });
    return { exact: exact, show: (exact.length ? exact : list).slice(0, 3) };
  }

  /* ------------------------------------------------------- Vorschlagsfeld */

  function attach(form) {
    var input = form.querySelector('input[name=q]');
    if (!input || input.getAttribute('data-rv24') === '1') { return; }
    input.setAttribute('data-rv24', '1');
    input.setAttribute('autocomplete', 'off');
    if (T.ph) { input.setAttribute('placeholder', T.ph); }

    if (window.getComputedStyle(form).position === 'static') { form.style.position = 'relative'; }

    var box = document.createElement('ul');
    box.className = 'rv24-sugg';
    box.hidden = true;
    form.appendChild(box);

    var timer = null;
    var skuHit = null;
    var active = -1;

    function close() { box.hidden = true; active = -1; }

    function render(items, skuItems, parsed) {
      var html = '';
      skuHit = null;

      if (parsed.sku && skuItems.length) {
        var r = skuRanked(skuItems, parsed.sku);
        if (r.exact.length === 1) { skuHit = r.exact[0].url; }
        html += '<li class="rv24-sugg__head">' + esc(T.itemno) + '</li>';
        r.show.forEach(function (it) { html += row(it, 'rv24-sugg__sku'); });
      }

      var url = filterUrl(parsed);
      if (!parsed.sku && url && (parsed.typ || parsed.dia)) {
        html += '<li class="rv24-sugg__jump"><a href="' + esc(url) + '">' +
          '<span class="rv24-sugg__txt"><span class="rv24-sugg__title">' + esc(filterLabel(parsed)) + '</span>' +
          '<span class="rv24-sugg__meta">' + esc(T.refine || '') + '</span></span></a></li>';
      }

      if (items.length) {
        html += '<li class="rv24-sugg__head">' + esc(T.items || '') + '</li>';
        items.forEach(function (it) { html += row(it); });
        html += '<li class="rv24-sugg__foot"><a href="' + esc(searchUrl(input.value)) + '">' +
          esc(T.all || '') + '</a></li>';
      } else if (!html) {
        html += '<li class="rv24-sugg__empty">' + esc(T.none || '') + '</li>';
      }

      box.innerHTML = html;
      box.hidden = false;
      active = -1;
    }

    function query() {
      var raw = input.value.trim();
      if (raw.length < 2) { close(); return; }
      var parsed = parse(raw);

      var jobs = [getJson(suggestUrl(searchTerm(raw), 'product', 6,
        'title,product_type,variants.title,variants.sku,tag,vendor'))];
      if (parsed.sku) {
        jobs.push(getJson(suggestUrl(parsed.sku, 'product', 5, 'variants.sku')));
      }

      Promise.all(jobs).then(function (res) {
        if (input.value.trim() !== raw) { return; }
        render(prods(res[0]), res[1] ? prods(res[1]) : [], parsed);
      });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(query, 180);
    });

    input.addEventListener('keydown', function (e) {
      var rows = box.querySelectorAll('li > a');
      if (e.key === 'Escape') { close(); return; }
      if (!rows.length || box.hidden) { return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active += (e.key === 'ArrowDown' ? 1 : -1);
        if (active < 0) { active = rows.length - 1; }
        if (active >= rows.length) { active = 0; }
        Array.prototype.forEach.call(box.querySelectorAll('li'), function (li) {
          li.classList.remove('is-active');
        });
        rows[active].parentNode.classList.add('is-active');
        rows[active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && active > -1) {
        e.preventDefault();
        window.location.href = rows[active].getAttribute('href');
      }
    });

    form.addEventListener('submit', function (e) {
      var raw = input.value.trim();
      if (!raw) { return; }
      var parsed = parse(raw);

      if (parsed.sku) {
        if (skuHit) { e.preventDefault(); window.location.href = skuHit; }
        return;
      }
      var url = filterUrl(parsed);
      if (url && parsed.typ && parsed.dia && !parsed.rest) {
        e.preventDefault();
        window.location.href = url;
      }
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) { close(); }
    });
  }

  /* ------------------------------------------ Suchergebnisseite ergaenzen */

  function enhanceResults() {
    var slot = document.getElementById('rv24-refine');
    if (!slot) { return; }
    var raw = '';
    try { raw = new URLSearchParams(window.location.search).get('q') || ''; } catch (e) { return; }
    if (!raw) { return; }

    var parsed = parse(raw);

    /* Artikelnummer-Treffer ganz oben */
    var skuSlot = document.getElementById('rv24-sku');
    if (skuSlot && parsed.sku) {
      getJson(suggestUrl(parsed.sku, 'product', 5, 'variants.sku')).then(function (d) {
        var list = prods(d);
        if (!list.length) { return; }
        var r = skuRanked(list, parsed.sku);
        var h = '<ul class="rv24-sugg rv24-sugg--static"><li class="rv24-sugg__head">' +
          esc(T.itemno) + ' ' + esc(parsed.sku) + '</li>';
        r.show.forEach(function (it) { h += row(it); });
        skuSlot.innerHTML = h + '</ul>';
      });
    }

    var url = filterUrl(parsed);
    if (url && (parsed.typ || parsed.dia)) {
      var extra = '';
      if (parsed.typ && parsed.dia) {
        extra += '<a href="' + esc(filterUrl({ dia: parsed.dia })) + '">' + esc(parsed.dia.l) + '</a>';
        extra += '<a href="' + esc(filterUrl({ typ: parsed.typ })) + '">' + esc(parsed.typ.l) + '</a>';
      }
      slot.innerHTML = '<div class="rv24-refine"><span class="rv24-refine__label">' +
        esc(T.refine || '') + '</span><a href="' + esc(url) + '">' +
        esc(filterLabel(parsed)) + '</a>' + extra + '</div>';
    }

    var pages = document.getElementById('rv24-pages');
    if (pages) {
      getJson(suggestUrl(searchTerm(raw), 'page,article', 4)).then(function (d) {
        var res = (d && d.resources && d.resources.results) || {};
        var list = (res.pages || []).concat(res.articles || []);
        if (!list.length) { return; }
        var h = '<div class="rv24-pages"><h4>' + esc(T.guide || '') + '</h4><ul>';
        list.forEach(function (it) {
          h += '<li><a href="' + esc(it.url) + '">' + esc(it.title) + '</a></li>';
        });
        pages.innerHTML = h + '</ul></div>';
      });
    }

    var dia = document.getElementById('rv24-dia-links');
    if (dia) {
      var hh = '';
      diaTags().forEach(function (t) {
        hh += '<a href="' + esc(filterUrl({ dia: t })) + '">' + esc(t.l) + '</a>';
      });
      if (hh) { dia.innerHTML = '<div class="rv24-nohits__dia">' + hh + '</div>'; }
    }
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('form[action*="/search"]'), attach);
    enhanceResults();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());